import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Day(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Day", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 34c5.5228 0 10-4.4772 10-10s-4.4772-10-10-10-10 4.4772-10 10 4.4772 10 10 10Zm0-23.5714c-.5429 0-.9048-.3619-.9048-.90479V5.90476C23.0952 5.3619 23.4571 5 24 5s.9048.3619.9048.90476v3.61905c0 .54289-.3619.90479-.9048.90479ZM24 43c-.5429 0-.9048-.3619-.9048-.9048v-3.619c0-.5429.3619-.9048.9048-.9048s.9048.3619.9048.9048v3.619c0 .5429-.3619.9048-.9048.9048Zm18.0952-18.0952h-3.619c-.5429 0-.9048-.3619-.9048-.9048s.3619-.9048.9048-.9048h3.619c.5429 0 .9048.3619.9048.9048s-.3619.9048-.9048.9048Zm-32.57139 0H5.90476C5.3619 24.9048 5 24.5429 5 24s.3619-.9048.90476-.9048h3.61905c.54289 0 .90479.3619.90479.9048s-.3619.9048-.90479.9048ZM13.7762 14.681c-.2714 0-.4524-.0905-.6333-.2715l-2.5334-2.5333c-.3619-.3619-.3619-.9048 0-1.2667.3619-.3619.9048-.3619 1.2667 0l2.5333 2.5334c.3619.3619.3619.9047 0 1.2666-.1809.181-.4524.2715-.6333.2715Zm-2.5333 22.9809c-.2715 0-.4524-.0905-.6334-.2714-.3619-.3619-.3619-.9048 0-1.2667l2.5334-2.5333c.3619-.3619.9047-.3619 1.2666 0s.3619.9047 0 1.2666l-2.5333 2.5334c-.181.1809-.4524.2714-.6333.2714ZM34.2238 14.681c-.2714 0-.4524-.0905-.6333-.2715-.3619-.3619-.3619-.9047 0-1.2666l2.5333-2.5334c.3619-.3619.9048-.3619 1.2667 0 .3619.3619.3619.9048 0 1.2667l-2.5334 2.5333c-.1809.181-.3619.2715-.6333.2715Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.7617 42.0953c3.9975 0 7.2381-3.2406 7.2381-7.2381s-3.2406-7.2381-7.2381-7.2381-7.2381 3.2406-7.2381 7.2381 3.2406 7.2381 7.2381 7.2381Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.7604 35.762c-.5428 0-.9047-.3619-.9047-.9048v-4.5238c0-.5428.3619-.9048.9047-.9048.5429 0 .9048.362.9048.9048v4.5238c0 .5429-.3619.9048-.9048.9048Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.3795 35.7616h-3.6191c-.5428 0-.9047-.3619-.9047-.9048 0-.5428.3619-.9047.9047-.9047h3.6191c.5428 0 .9047.3619.9047.9047 0 .5429-.3619.9048-.9047.9048Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Day.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Day"
};
validateTidalLicense();
export {
  Day
};
//# sourceMappingURL=Day.js.map
